module.exports = __webpack_public_path__ + "img/share.c723122b.png";